// const defaultTheme = {
//   primary: "#3F51B5",
//   secondary: "#f03b00",
//   accent: "#E86413",
//   error: "#f44336",
//   warning: "#ff9800",
//   info: "#03a9f4",
//   success: "#4caf50",
//   anchor: "red",
//   white: "#fff",
// };
// // #ededed
// // #f5f5f5
// export default defaultTheme;

const newTheme = {
  primary: process.env.VUE_APP_PRIMARY_COLOR || "#eab23c",
  secondary: process.env.VUE_APP_PRIMARY_COLOR || "#FB9716",
  accent: "#E86413",
  error: "#f44336",
  warning: "#ff9800",
  info: "#03a9f4",
  success: process.env.VUE_APP_PRIMARY_COLOR || "#FB9716",
  anchor: "red",
  rufous: "#212AD2",
  blue: "#212AD2",
  blue_light: "#c7e1fc",
  light: "#fff",
};
export default newTheme;
